"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../../components/ui/dialog";
import { imageService } from "../../../lib/services";

interface EspeceImagePreviewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  imgUrl: string;
  title: string;
  subtitle?: string;
}

export function EspeceImagePreviewDialog({
  open,
  onOpenChange,
  imgUrl,
  title,
  subtitle,
}: EspeceImagePreviewDialogProps) {
  const previewSrc = imageService.getOptimizedImageUrl(imgUrl, "espece", 1200, 900);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="gap-0 overflow-hidden p-0 sm:max-w-2xl">
        <DialogHeader className="space-y-1 border-b border-border/60 px-6 py-5 text-left">
          <DialogTitle className="text-lg font-semibold tracking-tight">{title}</DialogTitle>
          {subtitle ? (
            <DialogDescription className="text-sm">{subtitle}</DialogDescription>
          ) : null}
        </DialogHeader>

        <div className="bg-gradient-to-br from-muted/50 via-background to-muted/30 px-6 py-6">
          <div className="overflow-hidden rounded-xl border border-border/60 bg-background/90 shadow-sm ring-1 ring-border/20">
            <img
              src={previewSrc}
              alt={title}
              className="mx-auto max-h-[min(70vh,520px)] w-full object-contain p-4"
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
